/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Confirmation_Propose_HintInputs */



/**
* | output |
* | --- |
* | "Reads freely, pauses for approval before it saves, sends or changes anything." |
*
* @param {Agent_Builder_Confirmation_Propose_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_confirmation_propose_hint = /** @type {((inputs?: Agent_Builder_Confirmation_Propose_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Confirmation_Propose_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Liest frei, wartet vor jedem Speichern, Senden oder Ändern auf Freigabe.")
	return /** @type {LocalizedString} */ ("Reads freely, pauses for approval before it saves, sends or changes anything.")
});